import React from "react";

const BarrasInfo = ({ personales, financieros, otros }) => {
  const getAltura = (valor) => `${valor * 2}px`;

  return (
    <div className="flex items-end space-x-4 bg-[#e8f2f4] p-4 w-fit">
      <div className="flex flex-col items-center">
        <div className="text-white flex items-center justify-center text-md" style={{ background: "#276ae8", opacity: 0.7, height: getAltura(personales), width: "30px" }}>
          <span style={{ textShadow: '0px 2px 1px rgba(0,0,0,1)' }}>{personales}%</span>
        </div>
        <span className="text-[#276ae8] font-bold mt-2">Personales</span>
      </div>
      <div className="flex flex-col items-center">
        <div className="text-white flex items-center justify-center text-md" style={{ background: "#b127e8", opacity: 0.7, height: getAltura(financieros), width: "30px" }}>
          <span style={{ textShadow: '0px 2px 1px rgba(0,0,0,1)' }}>{financieros}%</span>
        </div>
        <span className="font-bold text-[#b127e8] mt-2">Financieros</span>
      </div>
      <div className="flex flex-col items-center">
        <div className="text-white flex items-center justify-center text-md" style={{ background: "#909d00", opacity: 0.7, height: getAltura(otros), width: "30px" }}>
          <span style={{ textShadow: '0px 2px 1px rgba(0,0,0,1)' }}>{otros}%</span>
        </div>
        <span className="font-bold text-[#909d00] mt-2">Otros</span>
      </div>
    </div>
  );
};

export default BarrasInfo;
